export default __webpack_public_path__ + "static/media/img-71.97260b9d.jpg";